import React from 'react';
import { Form } from 'react-bootstrap';

const MessageSection = ({
  subject,
  setSubject,
  message,
  setMessage,
  reminderFrequency,
  setReminderFrequency,
}) => {
  return (
    <div className="message-form">
      <div className="mb-3">
        <Form.Label>
          Subject <span className="text-danger">*</span>
        </Form.Label>
        <div className="position-relative">
          <Form.Control
            type="text"
            value={subject}
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue.length <= 100) {
                setSubject(newValue);
              }
            }}
            maxLength={100}
          />
          <span className="character-count">
            {subject.length}/100
          </span>
        </div>
      </div>

      <div className="mb-3">
        <Form.Label>Message</Form.Label>
        <div className="position-relative">
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Enter Message"
            value={message}
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue.length <= 10000) {
                setMessage(newValue);
              }
            }}
            maxLength={10000}
          />
          <span className="character-count">
            {message.length}/10000
          </span>
        </div>
      </div>

      <div className="mb-3">
        <Form.Label>Frequency of reminders</Form.Label>
        <Form.Select
          value={reminderFrequency}
          onChange={(e) => setReminderFrequency(e.target.value)}
          className="w-100"
        >
          <option value="Every day">Every day</option>
          <option value="Every 2 days">Every 2 days</option>
          <option value="Every 3 days">Every 3 days</option>
          <option value="Every week">Every week</option>
          <option value="Never">Never</option>
        </Form.Select>
      </div>
    </div>
  );
};

export default MessageSection;

